import React from 'react';

import { useIsAuthenticated } from '@azure/msal-react';

import { ExternalLink } from 'features/order-tracker/shared-components/ExternalLink';

import { BACK_TO_MY_ORDERS_LINK_TEXT, MY_ACCOUNT_ORDER_URL } from './constants';

import styles from './styles.module.scss';

export const BackToOrdersLink: React.FC = () => {
  const isAuthenticated = useIsAuthenticated();

  if (!isAuthenticated) return null;

  const REACT_APP_MY_ACCOUNT_DOMAIN = import.meta.env.VITE_MY_ACCOUNT_DOMAIN;
  const backToOrdersLink = `${REACT_APP_MY_ACCOUNT_DOMAIN}${MY_ACCOUNT_ORDER_URL}`;

  return (
    <ExternalLink
      iconClassName={styles.icon}
      className={styles.link}
      link={backToOrdersLink}
      text={BACK_TO_MY_ORDERS_LINK_TEXT}
      target="_self"
    />
  );
};
